import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2io333ig7s: FaireBrandEntity = {
  token: "b_2io333ig7s",
  type: "brand",
  name: "Ban.do",
  avatarUrl:
    "https://cdn.faire.com/fastly/472332246ffa9968e812e113de0374c8cba951469552dc86eb6bc197f1c40f3a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5896a33a23f0d0e1da33970ba274eb79f367c07861fd9e844c060354a1c07772.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/472332246ffa9968e812e113de0374c8cba951469552dc86eb6bc197f1c40f3a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5896a33a23f0d0e1da33970ba274eb79f367c07861fd9e844c060354a1c07772.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 111,
  isTopShop: true,
  isInsider: true,
  description:
    "We exist to help you be your best and we encourage joy. Everything we do starts with you: The products we make, our customer service, and the content we create. Ultimately you call the shots around here and that’s the way we like it.\n\nIn 2008 we created ban.do because we loved laughing, connecting and designing things that made people happy. Over a decade later a lot has changed, but why we do what we do and who we are hasn’t. At our core we are and have always been optimists who aspire to be better than great and less than perfect and firmly believe that being upside down is much more fun than being right side up.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:35.657Z",
    importedBy: "entity-db-cli",
  },
};
